import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './MediumInfoBlock.css'
import upIcon from '../Icons/icon-up.svg'
import downIcon from '../Icons/icon-down.svg'
import neutralIcon from '../Icons/icon-neutral.svg'

/**
 * Diplay for medium info block
 * @class
 * @extends Component
 */
class MediumInfoBlock extends Component {
  /** render function */
  render () {
    const { delta, sinceText, fontSmall } = this.props // Destructure fontSmall
    const deltaPct = delta ? `${(delta).toFixed(0)}%` : '0'
    const convertedSinceText = sinceText ? sinceText.charAt(0).toUpperCase() : null
    switch (this.props.title) {
      default:
        if (!sinceText) {
          return (
            <div className='MediumBlock'>
              <h5> {this.props.title}</h5>
              <div className='flex align-end space-between'>
                <div className='flex' style={{ flexBasis: fontSmall ? '100%' : '50%' }}>
                  {fontSmall // Conditionally render h2 or h1 based on fontSmall
                    ? <h2 id='durationValue' style={{ marginBottom: '9px', fontWeight: '600' }}>{this.props.value}</h2>
                    : <h1 id='durationValue'>{this.props.value}</h1>}
                </div>
              </div>
            </div>
          )
        }
        return (
          <div className='MediumBlock'>
            <h5> {this.props.title}</h5>
            <div className='flex align-end space-between'>
              <div className='flex'>
                {fontSmall // Conditionally render h2 or h1 based on fontSmall
                  ? <h2 id='durationValue'style={{ marginBottom: '9px', fontWeight: '600' }}>{this.props.value}</h2>
                  : <h1 id='durationValue'>{this.props.value}</h1>}
              </div>
              <div>
                <span>{convertedSinceText + sinceText.slice(1)}</span>
                <h3 className='flex align-center'>
                  { delta === null || typeof (delta) === 'undefined'
                    ? <div><h3 className='flex align-center'><img src={neutralIcon} alt='Neutral' /> ---%</h3></div>
                    : delta === 0
                      ? <div><h3 className='flex align-center'><img src={neutralIcon} alt='Neutral' /> {deltaPct}</h3></div>
                      : delta > 0
                        ? <div><h3 className='flex align-center'><img src={upIcon} alt='Up' />  {deltaPct}</h3></div>
                        : <div><h3 className='flex align-center'><img src={downIcon} alt='Down' />{deltaPct}</h3></div> }
                </h3>
              </div>
            </div>
          </div>
        )
    }
  }
}

MediumInfoBlock.propTypes = {
  delta: PropTypes.number,
  sinceText: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fontSmall: PropTypes.bool
}

export default MediumInfoBlock
